(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8512"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8512"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
function $d52a0976794368a4$var$updateCountDown() {
    const countDownDate = new Date("May 14, 2025 15:00:00").getTime();
    // Get todays date and time
    const now = new Date().getTime();
    // Find the diff between now an the count down date
    const diff = countDownDate - now;
    // if countdown underflows to negative numbers, hide it
    document.getElementById("section-countdown").hidden = diff < 0;
    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor(diff % 86400000 / 3600000);
    const minutes = Math.floor(diff % 3600000 / 60000);
    //skoňování data
    let daysText;
    if (days === 1) daysText = days + "&nbsp;den";
    else if (days >= 2 && days <= 4) daysText = days + "&nbsp;dny";
    else daysText = days + "&nbsp;dn\xed";
    let hoursText;
    if (hours === 1) hoursText = hours + "&nbsp;hodina";
    else if (hours >= 2 && hours <= 4) hoursText = hours + "&nbsp;hodiny";
    else hoursText = hours + "&nbsp;hodin";
    let minutesText;
    if (minutes === 1) minutesText = minutes + "&nbsp;minuta";
    else if (minutes >= 2 && minutes <= 4) minutesText = minutes + "&nbsp;minuty";
    else minutesText = minutes + "&nbsp;minut";
    document.getElementById("days").innerHTML = daysText;
    document.getElementById("hours").innerHTML = hoursText;
    document.getElementById("minutes").innerHTML = minutesText;
}
document.addEventListener("DOMContentLoaded", ()=>{
    $d52a0976794368a4$var$updateCountDown();
    setInterval($d52a0976794368a4$var$updateCountDown, 1000);
});



var $4bOH9 = parcelRequire("4bOH9");
function $d883650f4fefa978$var$onBgColorsLoaded() {
    document.getElementById("bg-colors-main").classList.add("bg-colors-loaded");
}
const $d883650f4fefa978$var$ENABLE_CLASS = "nav-sm-enabled";
document.addEventListener("DOMContentLoaded", function() {
    const logo = document.getElementById("logo");
    const navUl = document.querySelector("nav > ul");
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                logo.style.visibility = "hidden";
                const b = navUl.classList.contains($d883650f4fefa978$var$ENABLE_CLASS);
                navUl.classList.remove($d883650f4fefa978$var$ENABLE_CLASS);
                if (b) (0, $4bOH9.headerController).buildFixedElementsAndDarkSections();
            } else {
                logo.style.visibility = "visible";
                const b = navUl.classList.contains($d883650f4fefa978$var$ENABLE_CLASS);
                navUl.classList.add($d883650f4fefa978$var$ENABLE_CLASS);
                if (!b) (0, $4bOH9.headerController).buildFixedElementsAndDarkSections();
            }
        });
    });
    observer.observe(document.getElementById("section-main"));
    //display bg_colors after the top cutout has been loaded
    const image = document.getElementById("bg-colors-trigger");
    if (image.complete) $d883650f4fefa978$var$onBgColorsLoaded();
    else image.addEventListener("load", $d883650f4fefa978$var$onBgColorsLoaded);
});

})();
//# sourceMappingURL=index.a4bd5e00.js.map
